import { useEffect } from 'react';

const REFRESH_CONNECTION_INTERVAL = 1000 * 30; // 30 seconds

export function useNetworkConnectionDetector(
  threshold: number,
  onChange: (payload: { status: string; downlink: number }) => void,
) {
  useEffect(() => {
    let interval: any;
    let status = '';

    if (navigator?.connection) {
      const checkConnection = () => {
        const downlink = (navigator.connection?.downlink || 0) * 1000;
        const newStatus = downlink < threshold ? 'bad' : 'good';

        if (newStatus !== status) {
          status = newStatus;
          onChange({ status, downlink });
        }
      };

      interval = setInterval(checkConnection, REFRESH_CONNECTION_INTERVAL);
    }

    return () => clearInterval(interval);
  }, [navigator, threshold]);
}
